import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=13965c9c&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=13965c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13965c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13965c9c')) {
      api.createRecord('13965c9c', component.options)
    } else {
      api.reload('13965c9c', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=13965c9c&scoped=true&", function () {
      api.rerender('13965c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/Product.vue"
export default component.exports